import React, { useEffect, useState, useCallback, useRef } from "react";
import { unstable_batchedUpdates } from 'react-dom';
import { useDispatch, useSelector, useStore } from "react-redux";
import { IconButton } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { fetchPreDiuoByDoss } from "../../../redux/actions/preDiuoActions";
import { changeTitleName, changePdfFileName, changeIndication } from "../../../redux/actions/emailAction";
import { getCoverPageData, genPreDiuoPDF, getPreDiuoFile, getDataFromPgc } from "../Utils";
import { postFormData } from "../../DIUO/Utils";
import { constructionSiteConst, intervenantsCont } from "./Const";
import coordogecLogo from './coordogecLogo.jpg';
import moment from "moment";
import { Button } from "@material-ui/core";
import ArrowRight from "@material-ui/icons/ArrowRight";
import { Add as AddIcon, Save as SaveIcon, PictureAsPdf as PdfIcon, Visibility as VisibilityIcon, ArrowForward as ArrowForwardIcon } from "@material-ui/icons";
import history from "../../Routes/history";
import Header from "../../Header/Header";
import DocMenu from "../../DocMenu";
import NumDossPreDiuo from "../../NumDossPreDiuo";
import GenPdf from "../../GenPdf";
import LoadingOverlay from "../../LoadingOverlay";
import YesNoDialog from "../../YesNoDialog";
import "../../../Styles/PreDIUO/Page1.scss";

const PreDiuoPage1 = () => {
  const dispatch = useDispatch();
  const dossierValue = useSelector((state) => state.devis.dossierValue);
  const index = useSelector((state) => state.preDiuo.index);
  const preDiuoValue = useSelector((state) => state.preDiuo.preDiuoValue);
  const preDiuoByDoss = useSelector((state) => state.preDiuo.preDiuoByDoss);
  const preDiuoLoading = useSelector((state) => state.preDiuo.loading);
  const store = useStore();
  const lastPreDiuoValueRef = useRef(preDiuoValue);
  const lastDossierValueRef = useRef(dossierValue);

  const [isLoading, setIsLoading] = useState(false);
  // Progression de l'enregistrement affichée dans le LoadingOverlay : { text, progress } ou null
  const [saveProgress, setSaveProgress] = useState(null);
  const [disableButton, setDisableButton] = useState(false);
  const [openDialogCreate, setOpenDialogCreate] = useState(false);
  const [openDialogPgcNotFound, setOpenDialogPgcNotFound] = useState(false);
  const [imgCoverPage, setImgCoverPage] = useState(null);
  const [logoProjectOwner, setLogoProjectOwner] = useState(null);
  const [logoProjectManager, setLogoProjectManager] = useState(null);
  const [logoCoordoCon, setLogoCoordoCon] = useState(null);
  const [logoCoordoRea, setLogoCoordoRea] = useState(null);
  const [savedImages, setSavedImages] = useState({
    imgCoverPage: false,
    logoProjectOwner: false,
    logoProjectManager: false,
    logoCoordoCon: false,
    logoCoordoRea: false
  });

  const [isOpen, setIsOpen] = useState(false);
  const [file, setFile] = useState(null);

  const [constructionSite, setConstructionSite] = useState(constructionSiteConst);
  const [intervenants, setIntervenants] = useState(intervenantsCont);
  const [date, setDate] = useState(moment(new Date()).format("YYYY-MM-DD"));

  const setStateField = (e) => {
    const { name, value } = e.target;
    const [section, field] = name.split('.');

    setIntervenants(prevState => ({
      ...prevState,
      [section]: {
        ...prevState[section],
        [field]: value
      }
    }));
  };

  const imageHandlers = {
    'cover_page.jpg': setImgCoverPage,
    'logo_project_owner.jpg': setLogoProjectOwner,
    'logo_project_manager.jpg': setLogoProjectManager,
    'logo_coordo_con.jpg': setLogoCoordoCon,
    'logo_coordo_rea.jpg': setLogoCoordoRea
  };

  const resetCompaniesLogo = () => {
    setImgCoverPage(null);
    setLogoProjectOwner(null);
    setLogoProjectManager(null);
    fetch(coordogecLogo)
      .then(response => response.blob())
      .then(blob => {
        const file1 = new File([blob], 'coordogecLogo.jpg', { type: 'image/jpeg' });
        const file2 = new File([blob], 'coordogecLogo.jpg', { type: 'image/jpeg' });

        setLogoCoordoCon(file1);
        setLogoCoordoRea(file2);
      })
      .catch(error => console.error('Error loading default logo:', error));
  };

  const fetchDataFromPgc = async () => {
    if (!dossierValue || preDiuoValue) return;
    setIsLoading(true);

    const response = await getDataFromPgc(dossierValue);

    // Ignorer la réponse si le dossier ou l'indice a changé entre-temps : sinon les images du PGC écrasent celles du PréDIUO
    if (lastDossierValueRef.current !== dossierValue || lastPreDiuoValueRef.current !== preDiuoValue) {
      return;
    }

    if (response) {
      const constructionSiteData = JSON.parse(response.construction_site);
      const projectOwnerData = JSON.parse(response.project_owner);
      const projectManagerData = JSON.parse(response.project_manager);
      const coordoConData = intervenantsCont.coordoCon;
      const coordoReaData = intervenantsCont.coordoRea;

      unstable_batchedUpdates(() => {
        setConstructionSite({
          operation: constructionSiteData.operation || '',
          category: constructionSiteData.category || '',
          adress: constructionSiteData.adress || '',
          cp: constructionSiteData.cp || '',
          city: constructionSiteData.city || ''
        });

        setIntervenants(prevState => ({
          ...prevState,
          projectOwner: {
            name: projectOwnerData.name || '',
            complement: projectOwnerData.complement || '',
            adress: projectOwnerData.adress || '',
            cp: projectOwnerData.cp || '',
            city: projectOwnerData.city || '',
            tel: projectOwnerData.tel || ''
          },
          projectManager: {
            name: projectManagerData.name || '',
            complement: projectManagerData.complement || '',
            adress: projectManagerData.adress || '',
            cp: projectManagerData.cp || '',
            city: projectManagerData.city || '',
            tel: projectManagerData.tel || ''
          },
          coordoCon: {
            name: coordoConData.name,
            complement: coordoConData.complement,
            adress: coordoConData.adress,
            cp: coordoConData.cp,
            city: coordoConData.city,
            mail: coordoConData.mail,
            tel: coordoConData.tel
          },
          coordoRea: {
            name: coordoReaData.name,
            complement: coordoReaData.complement,
            adress: coordoReaData.adress,
            cp: coordoReaData.cp,
            city: coordoReaData.city,
            mail: coordoReaData.mail,
            tel: coordoReaData.tel
          }
        }));
        setDate(moment(new Date()).format('YYYY-MM-DD'));
        resetCompaniesLogo();

        if (response.images.length > 0) {
          response.images.forEach((image) => {
            const buffer = new Uint8Array(image.img.buffer.data).buffer;
            const blob = new Blob([buffer]);
            const file = new File([blob], image.name, { type: 'image/png' });

            const handler = imageHandlers[image.name];
            if (handler) {
              handler(file);
            }
          });
        }
      })
    } else {
      unstable_batchedUpdates(() => {
        setConstructionSite({
          operation: '',
          category: '',
          adress: '',
          cp: '',
          city: ''
        });

        setIntervenants(prevState => ({
          ...prevState,
          projectOwner: {
            name: '',
            complement: '',
            adress: '',
            cp: '',
            city: '',
            tel: ''
          },
          projectManager: {
            name: '',
            complement: '',
            adress: '',
            cp: '',
            city: '',
            tel: ''
          },
          coordoCon: {
            name: intervenantsCont.coordoCon.name,
            complement: intervenantsCont.coordoCon.complement,
            adress: intervenantsCont.coordoCon.adress,
            cp: intervenantsCont.coordoCon.cp,
            city: intervenantsCont.coordoCon.city,
            mail: intervenantsCont.coordoCon.mail,
            tel: intervenantsCont.coordoCon.tel
          },
          coordoRea: {
            name: intervenantsCont.coordoRea.name,
            complement: intervenantsCont.coordoRea.complement,
            adress: intervenantsCont.coordoRea.adress,
            cp: intervenantsCont.coordoRea.cp,
            city: intervenantsCont.coordoRea.city,
            mail: intervenantsCont.coordoRea.mail,
            tel: intervenantsCont.coordoRea.tel
          }
        }));
        setDate(moment(new Date()).format('YYYY-MM-DD'));
        resetCompaniesLogo();
        setOpenDialogPgcNotFound(true)
      })
    }

    setIsLoading(false);
  };

  const loadData = async () => {
    if (!preDiuoValue) {
      fetchDataFromPgc();
      return;
    }

    setIsLoading(true);
    const response = await getCoverPageData(preDiuoValue);

    if (lastPreDiuoValueRef.current !== preDiuoValue || lastDossierValueRef.current !== dossierValue) {
      setIsLoading(false);
      return;
    }

    if (response) {
      const constructionSiteData = JSON.parse(response.construction_site);
      const projectOwnerData = JSON.parse(response.project_owner);
      const projectManagerData = JSON.parse(response.project_manager);
      const coordoConData = JSON.parse(response.coordo_con);
      const coordoReaData = JSON.parse(response.coordo_rea);

      unstable_batchedUpdates(() => {
        setDate(response.date);
        setConstructionSite({
          operation: constructionSiteData.operation || '',
          category: constructionSiteData.category || '',
          adress: constructionSiteData.adress || '',
          cp: constructionSiteData.cp || '',
          city: constructionSiteData.city || ''
        });

        setIntervenants(prevState => ({
          ...prevState,
          projectOwner: {
            name: projectOwnerData.name || '',
            complement: projectOwnerData.complement || '',
            adress: projectOwnerData.adress || '',
            cp: projectOwnerData.cp || '',
            city: projectOwnerData.city || '',
            mail: projectOwnerData.mail || '',
            tel: projectOwnerData.tel || ''
          },
          projectManager: {
            name: projectManagerData.name || '',
            complement: projectManagerData.complement || '',
            adress: projectManagerData.adress || '',
            cp: projectManagerData.cp || '',
            city: projectManagerData.city || '',
            mail: projectManagerData.mail || '',
            tel: projectManagerData.tel || ''
          },
          coordoCon: {
            name: coordoConData.name || '',
            complement: coordoConData.complement || '',
            adress: coordoConData.adress || '',
            cp: coordoConData.cp || '',
            city: coordoConData.city || '',
            mail: coordoConData.mail || '',
            tel: coordoConData.tel || ''
          },
          coordoRea: {
            name: coordoReaData.name || '',
            complement: coordoReaData.complement || '',
            adress: coordoReaData.adress || '',
            cp: coordoReaData.cp || '',
            city: coordoReaData.city || '',
            mail: coordoReaData.mail || '',
            tel: coordoReaData.tel || ''
          }
        }));

        setImgCoverPage(null);
        setLogoProjectOwner(null);
        setLogoProjectManager(null);
        setLogoCoordoCon(null);
        setLogoCoordoRea(null);
        setSavedImages({ imgCoverPage: false, logoProjectOwner: false, logoProjectManager: false, logoCoordoCon: false, logoCoordoRea: false });

        if (response.images.length > 0) {
          const nameToKey = {
            'cover_page.jpg': 'imgCoverPage',
            'logo_project_owner.jpg': 'logoProjectOwner',
            'logo_project_manager.jpg': 'logoProjectManager',
            'logo_coordo_con.jpg': 'logoCoordoCon',
            'logo_coordo_rea.jpg': 'logoCoordoRea'
          };
          const newSavedImages = {};

          response.images.forEach((image) => {
            const buffer = new Uint8Array(image.img.buffer.data).buffer;
            const blob = new Blob([buffer]);
            const file = new File([blob], image.name, { type: 'image/png' });

            const handler = imageHandlers[image.name];
            if (handler) {
              handler(file);
              const key = nameToKey[image.name];
              if (key) newSavedImages[key] = true;
            }
          });

          setSavedImages(prev => ({ ...prev, ...newSavedImages }));
        }
      });
    }

    setIsLoading(false);
  };

  useEffect(() => {
    lastPreDiuoValueRef.current = preDiuoValue;
    lastDossierValueRef.current = dossierValue;

    // Attendre la liste des PréDIUO du dossier : sinon on charge le PGC pour rien
    // avant que preDiuoValue ne soit renseigné. Lecture via le store car NumDossPreDiuo
    // (enfant) peut avoir lancé la requête juste avant cet effet.
    if (store.getState().preDiuo.loading) return;

    loadData();
  }, [dossierValue, preDiuoValue, preDiuoLoading]);

  const handleDeleteImg = useCallback((name) => {
    switch (name) {
      case "img-cover-page":
        setImgCoverPage(null);
        break;
      case "logo-project-owner":
        setLogoProjectOwner(null);
        break;
      case "logo-project-manager":
        setLogoProjectManager(null);
        break;
      case "logo-coordo-con":
        setLogoCoordoCon(null);
        break;
      case "logo-coordo-rea":
        setLogoCoordoRea(null);
        break;
      default:
        break;
    }
  }, []);

  const handleCreatePreDiuo = async (e) => {
    e.preventDefault();
    setOpenDialogCreate(false);
    setDisableButton(true);
    setIsLoading(true);
    const newIndex = preDiuoByDoss.length;

    const formData = new FormData();
    formData.append('ndossier', dossierValue);
    formData.append('date', date);
    formData.append('index', newIndex);
    formData.append('constructionSite', JSON.stringify(constructionSite));
    formData.append('intervenants', JSON.stringify(intervenants));

    const imagesToUpload = [
      { fieldname: 'imgCoverPage', file: imgCoverPage },
      { fieldname: 'logoProjectOwner', file: logoProjectOwner },
      { fieldname: 'logoProjectManager', file: logoProjectManager },
      { fieldname: 'logoCoordoCon', file: logoCoordoCon },
      { fieldname: 'logoCoordoRea', file: logoCoordoRea }
    ].filter(({ file }) => file);

    try {
      await saveWithImages('/api/prediuo/create', formData, newIndex, imagesToUpload, "Création du Pré-DIUO...");
      dispatch(fetchPreDiuoByDoss(dossierValue));
    } catch (error) {
      console.error('Erreur lors de la création du Pré-DIUO:', error);
      alertSaveError(error, "de la création du Pré-DIUO");
    } finally {
      setDisableButton(false);
      setIsLoading(false);
      setSaveProgress(null);
    }
  };

  /**
   * Envoie d'abord les textes (et suppressions), puis les images une par une :
   * une seule requête avec toutes les images ne répondait jamais sur Gandi.
   */
  const saveWithImages = async (url, formData, targetIndex, imagesToUpload, firstStepText) => {
    // Étapes : les textes, puis chaque image
    const totalSteps = imagesToUpload.length + 1;

    setSaveProgress({ text: firstStepText, progress: 0 });
    await postFormData(url, formData);

    for (const [i, { fieldname, file }] of imagesToUpload.entries()) {
      setSaveProgress({ text: "Enregistrement...", progress: (i + 1) / totalSteps });

      const imageFormData = new FormData();
      imageFormData.append('ndossier', dossierValue);
      imageFormData.append('index', targetIndex);
      imageFormData.append('fieldname', fieldname);
      imageFormData.append('image', file);

      await postFormData('/api/prediuo/saveCoverPageImage', imageFormData);
    }

    setSaveProgress({ text: "Enregistrement...", progress: 1 });
  };

  const alertSaveError = (error, action) => {
    alert(error.name === "AbortError"
      ? "L'enregistrement a pris trop de temps. Rechargez la page pour vérifier ce qui a été enregistré."
      : `Erreur lors ${action} : ${error.message}`);
  };

  const handleUpdatePreDiuo = async (e) => {
    e.preventDefault();
    setDisableButton(true);
    setIsLoading(true);

    const formData = new FormData();
    formData.append('ndossier', dossierValue);
    formData.append('index', index);
    formData.append('preDiuoValue', preDiuoValue);
    formData.append('date', date);
    formData.append('constructionSite', JSON.stringify(constructionSite));
    formData.append('intervenants', JSON.stringify(intervenants));

    // N'envoyer que les images nouvellement sélectionnées (pas celles déjà sur le SFTP)
    const imagesToUpload = [
      { fieldname: 'imgCoverPage', file: imgCoverPage },
      { fieldname: 'logoProjectOwner', file: logoProjectOwner },
      { fieldname: 'logoProjectManager', file: logoProjectManager },
      { fieldname: 'logoCoordoCon', file: logoCoordoCon },
      { fieldname: 'logoCoordoRea', file: logoCoordoRea }
    ].filter(({ fieldname, file }) => file && !savedImages[fieldname]);

    const imagesToDelete = [];
    if (!imgCoverPage && savedImages.imgCoverPage) imagesToDelete.push('cover_page.jpg');
    if (!logoProjectOwner && savedImages.logoProjectOwner) imagesToDelete.push('logo_project_owner.jpg');
    if (!logoProjectManager && savedImages.logoProjectManager) imagesToDelete.push('logo_project_manager.jpg');
    if (!logoCoordoCon && savedImages.logoCoordoCon) imagesToDelete.push('logo_coordo_con.jpg');
    if (!logoCoordoRea && savedImages.logoCoordoRea) imagesToDelete.push('logo_coordo_rea.jpg');
    if (imagesToDelete.length > 0) formData.append('imagesToDelete', JSON.stringify(imagesToDelete));

    try {
      await saveWithImages('/api/prediuo/update', formData, index, imagesToUpload, "Enregistrement de la page de garde...");
      // Les images envoyées sont désormais enregistrées : un nouvel enregistrement ne doit pas les renvoyer
      setSavedImages({
        imgCoverPage: !!imgCoverPage,
        logoProjectOwner: !!logoProjectOwner,
        logoProjectManager: !!logoProjectManager,
        logoCoordoCon: !!logoCoordoCon,
        logoCoordoRea: !!logoCoordoRea
      });
    } catch (error) {
      console.error("Erreur lors de l'enregistrement de la page de garde:", error);
      alertSaveError(error, "de l'enregistrement de la page de garde");
    } finally {
      setDisableButton(false);
      setIsLoading(false);
      setSaveProgress(null);
    }
  }

  const handleGenClick = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let blob = await genPreDiuoPDF(preDiuoValue, dossierValue, index);
    if (blob) {
      setIsOpen(true);
      setFile(blob);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    setDisableButton(false);
  }, [preDiuoValue]);

  const handleShowPdf = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getPreDiuoFile(dossierValue, index, 'pdf');
    if (response.blob.size > 100) {
      setFile(response.blob);
      setIsOpen(true);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    setDisableButton(false);
  }, [preDiuoValue]);

  const handleGetPdfFile = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getPreDiuoFile(dossierValue, index, 'pdf');
    if (response.blob.type === 'application/pdf') {
      setFile(response.blob);
      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName))
    }
    setDisableButton(false);
  }, [preDiuoValue]);

  const handleGetWordFile = useCallback(async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getPreDiuoFile(dossierValue, index, 'word');
    if (response.blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      setFile(response.blob);
      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName))
    }
    setDisableButton(false);
  }, [preDiuoValue]);

  const handleChangeTitleName = useCallback(() => {
    dispatch(changeTitleName(`Pré DIUO`));
  }, [preDiuoValue]);

  const nextPage = () => {
    history.push("/prediuo/page2");
  }

  const goToCreatePGC = () => {
    history.push("/pgc/page1");
  }

  return (
    <div className="pre-diuo-page1">
      {isLoading && <LoadingOverlay text={saveProgress?.text} progress={saveProgress?.progress} />}
      <Header />
      <DocMenu
        file={file}
        getSourceFile={handleGetWordFile}
        getPDF={handleGetPdfFile}
        handleChangeTitleName={handleChangeTitleName}
        updateIndication={() => dispatch(changeIndication(index))}
      />
      <h1 className="title">Pré DIUO (Page de garde)</h1>
      <NumDossPreDiuo />
      <div className="container">
        <table className="custom-table">
          <tbody>
            <tr className="custom-cell">
              <td>Date</td>
              <td><input type="date" name="date" value={date} onChange={(e) => setDate(e.target.value)} /></td>
            </tr>
            <tr className="custom-cell-title">
              <td className="custom-cell-label" colSpan={2}><strong>CHANTIER</strong></td>
            </tr>
            <tr className="custom-cell">
              <td>Dossier</td>
              <td><span>{dossierValue}</span></td>
            </tr>
            <tr className="custom-cell">
              <td>Indice</td>
              <td><span>{index}</span></td>
            </tr>
            <tr className="custom-cell">
              <td>Catégorie</td>
              <td><span>{constructionSite.category}</span></td>
            </tr>
            <tr className="custom-cell">
              <td>Opération</td>
              <td><span>{constructionSite.operation}</span></td>
            </tr>
            <tr className="custom-cell">
              <td>Adresse</td>
              <td><span>{constructionSite.adress ? `${constructionSite.adress}, ${constructionSite.cp} - ${constructionSite.city}` : ''}</span></td>
            </tr>
            <tr className="custom-cell">
              <td>Image</td>
              <td>
                <input
                  type="file"
                  name="img-cover-page"
                  key={`img-cp`}
                  multiple
                  style={{
                    width: "97%",
                    pointerEvents: "visible",
                    fontSize: "14px",
                  }}
                  accept=".jpg, .jpeg, .png"
                  onChange={(e) => { setImgCoverPage(e.target.files[0]); setSavedImages(prev => ({ ...prev, imgCoverPage: false })); }}
                />
              </td>
            </tr>
            <tr className="custom-cell-title">
              <td className="custom-cell-label" colSpan={2}><strong>MAÎTRE D'OUVRAGE</strong></td>
            </tr>
            <tr className="custom-cell">
              <td>Nom</td>
              <td><input type="text" name="projectOwner.name" value={intervenants.projectOwner.name} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Complément</td>
              <td><input type="text" name="projectOwner.complement" value={intervenants.projectOwner.complement} placeholder="Facultatif" onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Adresse</td>
              <td><input type="text" name="projectOwner.adress" value={intervenants.projectOwner.adress} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Code postal</td>
              <td><input type="text" name="projectOwner.cp" value={intervenants.projectOwner.cp} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Ville</td>
              <td><input type="text" name="projectOwner.city" value={intervenants.projectOwner.city} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Mail</td>
              <td><input type="text" name="projectOwner.mail" value={intervenants.projectOwner.mail || ''} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Téléphone</td>
              <td><input type="text" name="projectOwner.tel" value={intervenants.projectOwner.tel} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Logo</td>
              <td>
                <input
                  type="file"
                  name="logo-project-owner"
                  key={`logo-pm`}
                  multiple
                  style={{
                    width: "97%",
                    pointerEvents: "visible",
                    fontSize: "14px",
                  }}
                  accept=".jpg, .jpeg, .png"
                  onChange={(e) => { setLogoProjectOwner(e.target.files[0]); setSavedImages(prev => ({ ...prev, logoProjectOwner: false })); }}
                />
              </td>
            </tr>
            <tr className="custom-cell-title">
              <td className="custom-cell-label" colSpan={2}><strong>MAÎTRE D'ŒUVRE</strong></td>
            </tr>
            <tr className="custom-cell">
              <td>Nom</td>
              <td><input type="text" name="projectManager.name" value={intervenants.projectManager.name} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Complément</td>
              <td><input type="text" name="projectManager.complement" value={intervenants.projectManager.complement} placeholder="Facultatif" onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Adresse</td>
              <td><input type="text" name="projectManager.adress" value={intervenants.projectManager.adress} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Code postal</td>
              <td><input type="text" name="projectManager.cp" value={intervenants.projectManager.cp} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Ville</td>
              <td><input type="text" name="projectManager.city" value={intervenants.projectManager.city} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Mail</td>
              <td><input type="text" name="projectManager.mail" value={intervenants.projectManager.mail || ''} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Téléphone</td>
              <td><input type="text" name="projectManager.tel" value={intervenants.projectManager.tel} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Logo</td>
              <td>
                <input
                  type="file"
                  name="logo-project-manager"
                  key={`logo-pm`}
                  multiple
                  style={{
                    width: "97%",
                    pointerEvents: "visible",
                    fontSize: "14px",
                  }}
                  accept=".jpg, .jpeg, .png"
                  onChange={(e) => { setLogoProjectManager(e.target.files[0]); setSavedImages(prev => ({ ...prev, logoProjectManager: false })); }}
                />
              </td>
            </tr>
            <tr className="custom-cell-thead">
              <td className="custom-cell-label" colSpan={2}><strong>COORDONNATEUR SPS</strong></td>
            </tr>
            <tr className="custom-cell-title">
              <td className="custom-cell-label" colSpan={2}><strong>PHASE CONCEPTION</strong></td>
            </tr>
            <tr className="custom-cell">
              <td>Entreprise</td>
              <td><input type="text" name="coordoCon.name" value={intervenants.coordoCon.name} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Contact</td>
              <td><input type="text" name="coordoCon.complement" value={intervenants.coordoCon.complement} placeholder="Facultatif" onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Adresse</td>
              <td><input type="text" name="coordoCon.adress" value={intervenants.coordoCon.adress} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Code postal</td>
              <td><input type="text" name="coordoCon.cp" value={intervenants.coordoCon.cp} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Ville</td>
              <td><input type="text" name="coordoCon.city" value={intervenants.coordoCon.city} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Mail</td>
              <td><input type="text" name="coordoCon.mail" value={intervenants.coordoCon.mail || ''} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Téléphone</td>
              <td><input type="text" name="coordoCon.tel" value={intervenants.coordoCon.tel} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Logo</td>
              <td>
                <input
                  type="file"
                  name="logo-coordo-con"
                  key={`logo-ccon`}
                  multiple
                  style={{
                    width: "97%",
                    pointerEvents: "visible",
                    fontSize: "14px",
                  }}
                  accept=".jpg, .jpeg, .png"
                  onChange={(e) => { setLogoCoordoCon(e.target.files[0]); setSavedImages(prev => ({ ...prev, logoCoordoCon: false })); }}
                />
              </td>
            </tr>
            <tr className="custom-cell-title">
              <td className="custom-cell-label" colSpan={2}><strong>PHASE REALISATION</strong></td>
            </tr>
            <tr className="custom-cell">
              <td>Entreprise</td>
              <td><input type="text" name="coordoRea.name" value={intervenants.coordoRea.name} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Contact</td>
              <td><input type="text" name="coordoRea.complement" value={intervenants.coordoRea.complement} placeholder="Facultatif" onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Adresse</td>
              <td><input type="text" name="coordoRea.adress" value={intervenants.coordoRea.adress} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Code postal</td>
              <td><input type="text" name="coordoRea.cp" value={intervenants.coordoRea.cp} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Ville</td>
              <td><input type="text" name="coordoRea.city" value={intervenants.coordoRea.city} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Mail</td>
              <td><input type="text" name="coordoRea.mail" value={intervenants.coordoRea.mail || ''} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Téléphone</td>
              <td><input type="text" name="coordoRea.tel" value={intervenants.coordoRea.tel} onChange={setStateField} /></td>
            </tr>
            <tr className="custom-cell">
              <td>Logo</td>
              <td>
                <input
                  type="file"
                  name="logo-coordo-rea"
                  key={`logo-crea`}
                  multiple
                  style={{
                    width: "97%",
                    pointerEvents: "visible",
                    fontSize: "14px",
                  }}
                  accept=".jpg, .jpeg, .png"
                  onChange={(e) => { setLogoCoordoRea(e.target.files[0]); setSavedImages(prev => ({ ...prev, logoCoordoRea: false })); }}
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div className="imgs">
          {renderImageItem(imgCoverPage, "img-cover-page", handleDeleteImg, "img page de garde", "Page de garde")}
          {renderImageItem(logoProjectOwner, "logo-project-owner", handleDeleteImg, "logo maitre d ouvrage", "Maître d'ouvrage")}
          {renderImageItem(logoProjectManager, "logo-project-manager", handleDeleteImg, "logo maitre d oeuvre", "Maître d'oeuvre")}
          {renderImageItem(logoCoordoCon, "logo-coordo-con", handleDeleteImg, "logo Coordonnateur Conception", "Coordonnateur Conception")}
          {renderImageItem(logoCoordoRea, "logo-coordo-rea", handleDeleteImg, "logo Coordonnateur Realisation", "Coordonnateur Realisation")}
        </div>
      </div>
      <div className="buttons-container">
        <Button
          color="primary"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpenDialogCreate(true)}
          disabled={disableButton}
        >
          Nouveau PRE DIUO
        </Button>
        <Button
          color="primary"
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={handleUpdatePreDiuo}
          disabled={disableButton || !preDiuoValue}
        >
          Enregistrer
        </Button>
        <Button
          color="primary"
          variant="contained"
          startIcon={<PdfIcon />}
          onClick={handleGenClick}
          disabled={disableButton || !preDiuoValue}
        >
          Générer
        </Button>
        <Button
          color="primary"
          variant="contained"
          startIcon={<VisibilityIcon />}
          onClick={() => handleShowPdf()}
          disabled={disableButton || !preDiuoValue}
        >
          Afficher
        </Button>
        <Button
          color="primary"
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          onClick={nextPage}
          disabled={disableButton || !preDiuoValue}
        >
          Suivant
        </Button>
        {disableButton && (
          <CircularProgress className="spinner" color="inherit" />
        )}
      </div>
      <YesNoDialog
        isOpen={openDialogCreate}
        title={'CRÉATION DIUO'}
        question={`Voulez-vous créer un nouvel indice Pré DIUO du dossier ${dossierValue} ?`}
        handleYesClick={handleCreatePreDiuo}
        handleClose={() => setOpenDialogCreate(false)}
      />
      <YesNoDialog
        isOpen={openDialogPgcNotFound}
        title={"ABSENCE PGC"}
        question={`Voulez-vous créer un PGC pour le dossier ${dossierValue} ?`}
        handleYesClick={goToCreatePGC}
        handleClose={() => setOpenDialogPgcNotFound(false)}
      />
      <GenPdf
        file={file}
        isOpen={isOpen}
        closeDoc={() => setIsOpen(false)}
        scale={1}
      />
    </div>
  );
};
const renderImageItem = (image, name, handleDelete, altText, description) => (
  image && (
    <div className="img-item">
      <IconButton
        className="item-delete"
        aria-label={`Supprimer ${name}`}
        title={`Supprimer ${name}`}
        onClick={() => handleDelete(name)}
      >
        <DeleteOutlineIcon fontSize="small" />
      </IconButton>
      <img
        src={URL.createObjectURL(image)}
        alt={altText}
      />
      <p>{description}</p>
    </div>
  )
);

export default PreDiuoPage1;